// Centralisation de l'URL de l'API backend
// Utilise la variable d'environnement Vite si disponible, sinon fallback localhost
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000';
